<template>
	<div class="body" ref="pdfDom" id="pdfDom">
		<div class="header"></div>
		<div class="container">
			<div class="c-wrap" style="width: 1100px">
				<div class="test-bulu">
					<div class="total-title">
						<div>{{ examName }}</div>
						<div>校级分析报告</div>
					</div>
					<div class="total-title-btn" @click="previewPage">导出PDF报告</div>
					<div class="total-desc">
						<p>
							<span style="font-weight: bold">{{ schoolName }}</span> 本次考试 (考试时间：<span>{{ examTime }}</span> )，
							<span style="font-weight: bold">{{ gradeName }}</span> 共 <span style="font-weight: bold">{{ classNum }}</span> 个班级，<span
								style="font-weight: bold"
								>{{ studentTotalNum }}</span
							>
							名学生参加考试。考试学科：<span style="font-weight: bold">{{ subjectInfo }} {{ subjectNum }}</span> 门学科。
						</p>
						<div>
							<p>
								{{ subjectDesc }}
							</p>
						</div>
					</div>
				</div>
				<div class="content-main">
					<!-- 总体情况汇总分析 -->
					<summary-Analysis
						:totalGradeData="[totalGradeData]"
						:subjectGradeData="subjectGradeData"
						class="summaryAnalysis"
						:class="newFlag ? 'current' : ''"
					/>
					<!-- 总分分布 -->
					<total-Grade-Range
						class="totalGradeRange"
						:class="newFlag ? 'current' : ''"
						:gradingData="gradingData"
						:maxScore="maxScore"
						:minScore="minScore"
						:avgScore="avgScore"
						:isShowMore="isShowMore"
					/>
					<!-- 总分分档上线人数分布 -->
					<new-Total-Online-People class="totalOnlinePeople" :rateType="rateType" />
					<!-- 分段人数分布 -->
					<subSection-Population :class="newFlag ? 'current' : ''" class="subSectionPopulation" />
					<!-- 一分三率分析 -->
					<subject-Test-Performance :class="newFlag ? 'current' : ''" class="subjectTestPerformance" />
					<!-- 等级分析 -->
					<total-Level-Analysis :class="newFlag ? 'current' : ''" class="totalLevelAnalysis" />
					<!-- 重点学生信息 -->
					<key-Students :class="newFlag ? 'current' : ''" class="keyStudents" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SummaryAnalysis from '../utils/components/school/SummaryAnalysis'
import TotalGradeRange from '../utils/components/school/TotalGradeRange'
import newTotalOnlinePeople from '../utils/components/school/newTotalOnlinePeople'
import SubSectionPopulation from '../utils/components/school/newSubSectionPopulation'
import SubjectTestPerformance from '../utils/components/school/newSubjectTestPerformance'
import TotalLevelAnalysis from '../utils/components/school/newTotalLevelAnalysis'
import KeyStudents from '../utils/components/school/newKeyStudents'
export default {
	name: 'record',
	components: {
		SummaryAnalysis,
		TotalGradeRange,
		newTotalOnlinePeople,
		SubSectionPopulation,
		SubjectTestPerformance,
		TotalLevelAnalysis,
		KeyStudents
	},
	data() {
		return {
			menus: [
				{
					name: '总体情况汇总',
					className: 'summaryAnalysis'
				},
				{
					name: '总分分布',
					className: 'totalGradeRange'
				},
				{
					name: '总分分档上线人数分布',
					className: 'totalOnlinePeople'
				},
				{
					name: '分段人数分布',
					className: 'subSectionPopulation'
				},
				{
					name: '一分三率分析',
					className: 'subjectTestPerformance'
				},
				{
					name: '等级分析',
					className: 'totalLevelAnalysis'
				},
				{
					name: '重点学生',
					className: 'keyStudents'
				}
			],
			options: [
				{ label: '按比例分档', type: '7' }, //7
				{ label: '按分数分档', type: '8' } //8
			],
			classNum: '',
			gradeName: '',
			studentTotalNum: '',
			subjectInfo: '',
			subjectNum: '',
			subjectDesc: '',
			totalGradeData: [],
			subjectGradeData: [],
			activeIndex: '0',
			rateType: '',
			gradeType: '',
			offsetTop: 0,
			offsetHeight: 0,
			scrollTopArrs: [],
			clickScrollFlag: false,
			isShowSummary: false,
			maxScore: '',
			minScore: '',
			avgScore: '',
			examTime: '',
			examName: '',
			schoolName: '',
			gradingData: [],
			newFlag: true,
			query: this.$route.query,
			isShowMore: true
		}
	},
	created() {
		this.$screenRation()
		this.getOptions()
		this.getSummrayData()
	},
	methods: {
		getOptions() {
			this.options.forEach((item, index) => {
				if (index == 0) {
					this.rateType = item.type
				} else if (index == 1) {
					this.gradeType = item.type
				}
			})
		},
		//预览图片
		previewPage() {
			const _this = this
			this.isShowMore = false
			setTimeout(function() {
				// _this.$print(_this.$refs.pdfDom)
				_this.prints()
			}, 3000)
		},

		prints() {
			let oldStr = window.document.body.outerHTML
			Promise.resolve()
				.then(() => {
					getInputs()
				})
				.then(() => {
					getTextarea()
				})
				.then(() => {
					getSelect()
				})
				.then(() => {
					getCanvas()
				})
				.then(() => {
					let newStr = document.querySelector('#pdfDom').innerHTML
					window.document.body.innerHTML = newStr + getStyle()
					window.print()
					window.document.body.innerHTML = oldStr
					window.location.reload()
				})

			function getStyle() {
				let str = ''
				const styles = document.querySelectorAll('style,link')
				for (var i = 0; i < styles.length; i++) {
					if (styles[i].outerHTML.startsWith('<style')) {
						str += styles[i].outerHTML
					}
				}
				str += `
			  <style>
			    @media print {
			      body, html,#pdfDom {
			        height: auto !important;
			      }
			    }
			  </style>
			`
				console.log(str)
				return str
			}
			function getInputs() {
				var inputs = document.querySelectorAll('input')
				for (var k = 0; k < inputs.length; k++) {
					if (inputs[k].type == 'checkbox' || inputs[k].type == 'radio') {
						if (inputs[k].checked == true) {
							inputs[k].setAttribute('checked', 'checked')
						} else {
							inputs[k].removeAttribute('checked')
						}
					} else if (inputs[k].type == 'text') {
						inputs[k].setAttribute('value', inputs[k].value)
					} else {
						inputs[k].setAttribute('value', inputs[k].value)
					}
				}
			}
			function getTextarea() {
				var textareas = document.querySelectorAll('textarea')
				for (var k2 = 0; k2 < textareas.length; k2++) {
					if (textareas[k2].type == 'textarea') {
						textareas[k2].innerHTML = textareas[k2].value
					}
				}
				return textareas.outerHTML
			}
			function getSelect() {
				var selects = document.querySelectorAll('select')
				for (var k3 = 0; k3 < selects.length; k3++) {
					if (selects[k3].type == 'select-one') {
						var child = selects[k3].children
						for (var i in child) {
							if (child[i].tagName == 'OPTION') {
								if (child[i].selected == true) {
									child[i].setAttribute('selected', 'selected')
								} else {
									child[i].removeAttribute('selected')
								}
							}
						}
					}
				}
			}
			function getCanvas() {
				var canvas = document.querySelectorAll('canvas')
				for (var k4 = 0; k4 < canvas.length; k4++) {
					var imageURL = canvas[k4].toDataURL('image/png')
					var img = document.createElement('img')
					img.src = imageURL
					canvas[k4].parentNode.insertBefore(img, canvas[k4].nextElementSibling)
				}
			}
		},

		selectMenu(index) {
			this.getScroll()
			this.clickScrollFlag = true
			this.activeIndex = index.toString()
			document.body.scrollTop = document.documentElement.scrollTop = this.scrollTopArrs[index]
		},
		getSummrayData() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId
			}
			this.$post('reportApi/selectTotalScoreBase', params).then(res => {
				var resData = res
				if (resData.code === '200') {
					this.examTime = resData.data.examDate
					this.classNum = resData.data.classNum
					this.studentTotalNum = resData.data.totalNum
					this.gradeName = resData.data.gradeName
					this.examName = resData.data.examName
					this.maxScore = resData.data.maxScore.toString()
					this.minScore = resData.data.minScore.toString()
					this.avgScore = resData.data.avgScore.toString()
					this.subjectInfo = resData.data.subjectInfo
					this.subjectNum = resData.data.subjectNum
					this.subjectDesc = resData.data.describe
					this.totalGradeData = resData.data.tableOptions
					this.subjectGradeData = resData.data.subTableOptions
					this.schoolName = resData.data.schoolName
					this.isShowSummary = true
					this.gradingData = resData.data.gradeTableOptions.reverse()
				}
			})
		},
		getScroll() {
			this.scrollTopArrs = []
			const menuHeight = this.$refs.header.offsetHeight
			for (let item of this.menus) {
				this.scrollTopArrs.push(document.querySelector(`.${item.className}`).offsetTop - menuHeight)
			}
		},
		handleScroll() {
			// 得到页面滚动的距离，兼容写法
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if (this.clickScrollFlag) {
				if (scrollTop === this.scrollTopArrs[this.activeIndex]) {
					this.clickScrollFlag = false
				}
			} else {
				//当第一次滑动时 当前滚动条的距离小于第一个div盒子的滑动距离，默认给第一个小li激活样式
				if (scrollTop <= this.scrollTopArrs[0]) {
					this.activeIndex = '0'
					return
				}
				//若当前滚动条滑动的距离超过最后一个div盒子所滑动的距离，那么默认给最后一个小li添加样式
				if (scrollTop >= this.scrollTopArrs[this.scrollTopArrs.length - 1]) {
					this.activeIndex = (this.scrollTopArrs.length - 1).toString()
					return
				}
				//第一次滚动条滑动的距离大于第一个div盒子所滑动的距离且小于下一个div盒子所滑动的距离还是给当前的小li默认添加样式，往后以此类推，同理
				for (let i = 0; i < this.scrollTopArrs.length; i++) {
					if (i < this.scrollTopArrs.length && scrollTop >= this.scrollTopArrs[i] && scrollTop < this.scrollTopArrs[i + 1]) {
						this.activeIndex = i.toString()
						return
					}
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
@media print {
	.total-title-btn {
		display: none;
	}
}
.current {
	//margin: 0;
	//margin-top: -35px;
	padding: 30px;
	border: 1px solid transparent;
}
.flip-list-move {
	transition: linear 0.5s;
}
.body {
	margin: 0;
	padding: 0;
	background-color: #eff1f4;
	font-size: 14px;
}
.issFixed {
	width: 1198px;
	margin: 0 auto;
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	z-index: 4;
}
.school-nav {
	top: 0;
	position: sticky;
	z-index: 10;
	background: #fff;
}

.container {
	width: 100%;
	height: auto;
	.c-wrap {
		width: 1200px;
		margin: 10px auto;
		height: auto;
		box-sizing: border-box;
		// border: 1px solid skyblue;
		.test-bulu {
			position: relative;
			width: 100%;
			height: auto;
			// background-color: skyblue;
			// overflow: hidden;
			.total-title {
				box-sizing: border-box;
				width: 100%;
				height: auto;
				padding: 30px;
				color: #fff;
				border-top-left-radius: 3px;
				border-top-right-radius: 3px;
				background-color: #009688;
				overflow: hidden;
				& > div:nth-child(1) {
					margin-top: 0;
					font-size: 25px;
					text-align: center;
				}
				& > div:nth-child(2) {
					margin-top: 1px;
					font-size: 18px;
					text-align: center;
				}
			}
			.total-title-btn {
				position: fixed;
				top: 15px;
				right: 15px;
				width: 120px;
				height: 34px;
				text-align: center;
				font-size: 12px;
				line-height: 34px;
				background-color: #fff;
				color: #909399;
				border-radius: 20px;
				transition: all 0.2s linear;
				&:hover {
					background-color: #009688;
					color: #fff;
					border: 1px solid #fff;
					cursor: pointer;
				}
			}
			.total-desc {
				width: 100%;
				height: auto;
				background-color: #fff;
				font-size: 14px;
				color: #333;
				border-radius: 2px;
				padding: 20px 30px;
				// border-bottom: 1px solid #eee;
				box-sizing: border-box;
				& > p {
					margin-bottom: 10px;
				}
			}
		}
		.school-nav {
			.el-menu-item {
				padding: 0 17.5px;
			}
		}
		.content-main {
			width: 100%;
			height: auto;
			font-size: 14px;
			// margin-top: 12px;
		}
		.footer {
			// height: auto;
			padding: 40px;
			background-color: #009688;
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-size: 25px;
		}
	}
}

// /deep/.el-menu--horizontal {
// 	.el-menu-item.is-active {
// 		transition: linear 0.4s;
// 	}
// }
// .current {
// 	border-bottom: 1px solid #409eff;
// 	transition: linear 0.4s;
// }
// /deep/.el-button--primary {
// 	background-color: #009688;
// 	border-color: #009688;
// }
</style>
